import { EventGQL } from '../../Api'
import { allYearsLabel } from '../../Config/config'
import {
  CURRENT_YEAR,
  EVENTS_YEAR,
  PLL_FIRST_YEAR,
  STANDINGS_YEAR,
  STATS_YEAR,
} from '../../Config/League/league.config'
import {
  homecomingWeekends,
  MarketSelector,
  marketSelectors,
} from '../../Config/Season/season'
import { SEASON_SELECTOR_TYPES, SeasonSelectorType } from '../../Constant/season'
import { SeasonType } from '../../Context/SeasonContext/SeasonContext'

// Options for season segments
export const SEASON_SEGMENT_NAMES: { [key: string]: SeasonType } = {
  regular: 'regular',
  post: 'post',
  allstar: 'allstar',
  champseries: 'champseries',
}

/**
 *
 * Returns a list of years to be used in the year dropdown
 * @param seasonSelectorType - main or standings
 */
export const createYearDropdownList = (
  yearSelectType: SeasonSelectorType,
  requireAllYear: boolean,
  sortBy: 1 | -1 //ASC or DEC
) => {
  let yearList = []
  if (yearSelectType === SEASON_SELECTOR_TYPES.STANDINGS) {
    for (let i = PLL_FIRST_YEAR; i <= STANDINGS_YEAR; i++) {
      yearList.push({ value: i, label: i.toString() })
    }
  } else {
    for (let i = PLL_FIRST_YEAR; i <= CURRENT_YEAR; i++) {
      yearList.push({ value: i, label: i.toString() })
    }
  }
  const sorted = sortBy < 0 ? yearList.reverse() : yearList
  return requireAllYear ? [allYearsLabel, ...sorted] : sorted
}

export const determineSeasonStatsStatus = (events: EventGQL[]) => {
  let yearDiff = EVENTS_YEAR - STATS_YEAR
  if (yearDiff === 0) {
    // Reg season just started
    if (events.length > 0 && events[0].eventStatus > 0) {
      //Season is in progress
      return 'Current'
    }
    return 'Pending'
  }
  return 'Previous'
}

/**
 *
 * Returns team code for homecoming weekend or null
 */
export const isHomecomingWeekend = (market: string, segment: string) => {
  if (segment === SEASON_SEGMENT_NAMES.post) {
    return null
  }
  if (market in homecomingWeekends) {
    return homecomingWeekends[market]
  }
  return null
}

/**
 *
 * Returns the team name and Homecoming for the title
 */
export const generateHomecomingTitle = (teamCode: string) => {
  const titles: { [key: string]: string } = {
    ATL: 'Atlas Homecoming',
    CHA: 'Chaos Homecoming',
    WHP: 'Whipsnakes Homecoming',
    OUT: 'Outlaws Homecoming',
    ARC: 'Archers Homecoming',
    CAN: 'Cannons Homecoming',
    WAT: 'Waterdogs Homecoming',
    RED: 'Redwoods Homecoming',
  }
  return titles[teamCode] || `${teamCode} Homecoming`
}

export const getCurrentMarket = (): MarketSelector => {
  const now = Date.now() / 1000
  const currentMarket = marketSelectors.find(
    (market) => market.openTime <= now && market.closeTime >= now
  )
  //Default to the first market or last market if no market is found
  if (!currentMarket) {
    return now < marketSelectors[0].openTime
      ? marketSelectors[0]
      : marketSelectors[marketSelectors.length - 1]
  }
  return currentMarket
}

export const getMarketByName = (name: string): MarketSelector => {
  const foundMarket = marketSelectors.find((market) =>
    market.name.toLowerCase().includes(name.toLowerCase())
  )
  return foundMarket ?? marketSelectors[0]
}
